import * as React from 'react';
import { Separator } from 'telia-front-react';

interface IZebraPaddingProps {
  children?: React.ReactNode;
}

export default class ZebraPadding extends React.Component<IZebraPaddingProps> {
  public render(): JSX.Element {
    return (
      <>
        <Separator spacing="medium-plus" color="invisible" />
        {this.props.children}
        <Separator spacing="medium-plus" color="invisible" />
      </>
    );
  }
}
